const BREAKPOINT_MOBILE = 767;

const body           = document.body;
const html           = document.documentElement;
const HeaderBar      = document.querySelector( '.header__bar' );
const HeaderBarTrack = document.querySelector( '.header__bar-tracker' );
const Footer         = document.querySelector( '.footer' );
const Newsletter     = document.querySelector( '.newsletter--horizontal' );
const transform      = getSupportedPropertyName( [ 'transform', 'webkitTransform' ] ) || 'transform';
let scrollTop        = 0;
let screenHeight     = 0;
let documentHeight   = 0;
let windowWidth      = 0;
let footerHeight     = 0;
let newsletterHeight = 0;
let ticking          = false;

function Constructor() {

    if ( !HeaderBarTrack ) return;

    onResize();
    onScroll();

    if ( windowWidth > BREAKPOINT_MOBILE ) {
        window.addEventListener( 'scroll', onScroll, false );
        window.addEventListener( 'resize', onResize, false );
    }
}

function calculatePercent() {
    ticking = false;

    // Cuando documentHeight sea negativo quiere decir que la nota es tan chica que no hay scroll
    // suficiente para recorrer, en ese caso ocultamos headerbar.
    if( documentHeight < 0 ) {
        HeaderBar.style.opacity = '0';
    } else {
        HeaderBar.style.opacity = '1';
    }

    HeaderBarTrack.style[ transform  ] = 'scaleX(' + scrollTop / documentHeight + ')';
}

function onScroll() {
    scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    requestTick();
}

function requestTick() {
    if ( !ticking ) {
        requestAnimationFrame( calculatePercent );
    }
    ticking = true;
}

function onResize() {
    footerHeight = Footer.clientHeight;

    if( Newsletter ) {
        newsletterHeight = Newsletter.clientHeight;
    }

    windowWidth = window.innerWidth || html.clientWidth || body.clientWidth;
    screenHeight = window.innerHeight || html.clientHeight || body.clientHeight;
    documentHeight = Math.max( body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight ) - screenHeight - newsletterHeight - footerHeight;

    if ( windowWidth > BREAKPOINT_MOBILE ) {
        window.addEventListener( 'scroll', onScroll, false );
    } else {
        window.removeEventListener( 'scroll', onScroll, false );
    }
}

function getSupportedPropertyName( props ) {
    for ( var i = 0; i < props.length; i++ ) {
        if ( typeof document.body.style[props[i]] != 'undefined' ) {
            return props[i];
        }
    }
    return null;
}

export default Constructor;